import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as XLSX from "xlsx";
import {forkJoin, Observable, Subject} from "rxjs";
import {Centre} from "../../../../interfaces/Centres";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {CentreService} from "../../../../services/centre.service";
import {MatDialog} from "@angular/material/dialog";
import {LoadingService} from "../../../../services/loading.service";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {map, takeUntil} from "rxjs/operators";
import {OccupancyReport} from "../occupancy-reports/occupancy-reports.component";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";
import {FinancialYearService} from "../../../../services/financial-year.service";

export interface EfficiencyReports {
  available: number;
  centreCode: string;
  date: any
  occupied: number;
  totalOccupancy: number
}

@Component({
  selector: 'app-efficiency-report',
  templateUrl: './efficiency-report.component.html',
  styleUrls: ['./efficiency-report.component.scss']
})
export class EfficiencyReportComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  startDate1: Date | null = null;
  endDate1: Date | null = null;
  efficiencyReports: EfficiencyReports[] = [];
  filteredEfficiencyReports: any[] = [];
  centres$: Observable<Centre[]>;


  selectedCentreCode: string[] = [];   // supports multi-select
  selectedCentre: Centre[] = [];
  // selectedCentre:any;
  // displayCentre = (c: any) => c?.centreName;
  // selectedCentreCode: any = ''
  TotalDays: any;
  TSumDays: any;
  totalUnits: any;
  centres: Centre[] = [];
  displayedColumns: string[] = ['Sr', 'centreName','totalUnit','noOfDays','totalOccupancy', 'occupied', 'available', 'percentage'];
  dataSource!: MatTableDataSource<EfficiencyReports>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private firestore: AngularFirestore,
              private mCentreService: CentreService,
              private dialog: MatDialog,
              private loadingService: LoadingService,
              private readonly financialYearService: FinancialYearService,) {
    this.centres$ = this.mCentreService.getAllCentres();
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe((centres) => {
      this.centres = centres;
    });
  }

  // Add this method for displayWithFn
  displayCentre = (centre: Centre): string => {
    return centre ? centre.centreName : '';
  }


  // Method to get centreName by centreCode
  getCentreNameByCode(centreCode: string): string {
    const centre = this.centres.find(c => c.centreCode === centreCode);
    return centre ? centre.centreName : 'Unknown Centre';  // Return 'Unknown Centre' if not found
  }

  // onCentreSelect(selectedCentre: Centre) {
  //   if (!selectedCentre) return;
  //
  //   console.log("Selected Centre:", selectedCentre);
  //
  //   this.selectedCentre = selectedCentre;
  //
  //   // // 1️⃣ Set centre details in form
  //   // this.studentForm.patchValue({
  //   //   centreName: selectedCentre.centreName,
  //   //   centreCode: selectedCentre.centreCode
  //   // });
  // }

  onCentreSelect(selectedCentre: Centre | Centre[]) {

    if (!selectedCentre || (Array.isArray(selectedCentre) && selectedCentre.length === 0)) {
      this.selectedCentre = [];
      this.selectedCentreCode = [];
      return;
    }

    // Normalize to array
    const centres = Array.isArray(selectedCentre) ? selectedCentre : [selectedCentre];

    this.selectedCentre = centres;
    this.selectedCentreCode = centres.map(c => c.centreCode);

    console.log('Selected Centres:', this.selectedCentreCode);
  }

  getTotalUnits(): number {
    return this.dataSource?.data?.reduce((sum, item:any) => sum + (item.totalUnits || 0), 0);
  }

  onEndDateChanged() {

  }
  sumTotalUnits:any
  SearchData() {
    this.loadingService.setLoading(true);

    if (!this.startDate1 || !this.endDate1 || !this.selectedCentreCode) {
      alert('Please select a valid date range and center.');
      this.loadingService.setLoading(false);
      return;
    }
    const adjustedEndDate = new Date(this.endDate1!);
    adjustedEndDate.setHours(23, 59, 59, 999);

    // Firestore Query with WHERE condition
    this.firestore.collection<EfficiencyReports>('occupancy', ref =>
      ref.where('date', '>=', this.startDate1)
        .where('date', '<=', adjustedEndDate)
        .where('centreCode', 'in', this.selectedCentreCode)
    ).valueChanges({ idField: 'id' }).pipe(takeUntil(this._destroyed$)).subscribe((data: EfficiencyReports[]) => {
      // Adjust end date to include full day
      const adjustedEndDate = new Date(this.endDate1!);
      adjustedEndDate.setHours(23, 59, 59, 999);
      const startDate = this.startDate1!.getTime();
      const endDate = adjustedEndDate.getTime();

// Object to store grouped data by center code
      const groupedByCenter: { [centreCode: string]: OccupancyReport[] } = {};

// No center selected → filter all by date
      if (!this.selectedCentreCode || this.selectedCentreCode.length === 0) {
        const filteredData = data.filter((res: OccupancyReport) => {
          const reportDate = res.date.toDate().getTime();
          return reportDate >= startDate && reportDate <= endDate;
        });

        // Group filtered data by centreCode
        filteredData.forEach(res => {
          if (!groupedByCenter[res.centreCode]) {
            groupedByCenter[res.centreCode] = [];
          }
          groupedByCenter[res.centreCode].push(res);
        });

      } else {
        // Centers selected → loop through each
        this.selectedCentreCode.forEach((centerCode: string) => {
          const centerData = data.filter((res: OccupancyReport) => {
            const reportDate = res.date.toDate().getTime();
            return res.centreCode === centerCode && reportDate >= startDate && reportDate <= endDate;
          });

          if (!groupedByCenter[centerCode]) {
            groupedByCenter[centerCode] = [];
          }
          groupedByCenter[centerCode].push(...centerData);
        });
      }
      let totalDays = 0;
// Now you can loop groupedByCenter to show center-wise data
      console.log('Grouped Data:', groupedByCenter);
      Object.keys(groupedByCenter).forEach(code => {
        const centerRecords = groupedByCenter[code];
        console.log(`Center: ${code}, Records: ${centerRecords.length}`);
        this.TotalDays = centerRecords.length;
        totalDays += centerRecords.length;
      });
      this.TSumDays = totalDays;

// You can store groupedByCenter in a variable for table or UI
//       this.groupedOccupancyData = groupedByCenter;


      this.loadingService.setLoading(false);
      // **Group Data by `centreCode` and sum totals**
      let groupedData = data.reduce((acc, curr) => {
        let existing = acc.find(item => item.centreCode === curr.centreCode);
        if (existing) {
          existing.totalOccupancy += curr.totalOccupancy;
          existing.occupied += curr.occupied;
          existing.available += curr.available;
        } else {
          acc.push({ ...curr });
        }
        return acc;
      }, [] as EfficiencyReports[]);

      // **Calculate percentage for each center**
      let totalUnits = 0
      groupedData.forEach((item: any) => {
        item.percentage = item.totalOccupancy > 0 ? (item.occupied / item.totalOccupancy) * 100 : 0;
        // Merge totalUnits from Firestore
        const observables = groupedData.map((item:any) =>
          this.mCentreService.getCenterByCode(item.centreCode).pipe(
            map((center:any) => {
              item.totalUnits = center?.totalUnits || 0;
              totalUnits += center?.totalUnits || 0;
              this.totalUnits = totalUnits;
              return item;
            }
            )
          )
        );
        forkJoin(observables).subscribe(updatedData => {
          groupedData = updatedData;
          this.dataSource = new MatTableDataSource(groupedData);
        });
      });

      // **Update Table Data**
      this.efficiencyReports = groupedData;
      this.dataSource = new MatTableDataSource(this.efficiencyReports);
      this.dataSource.paginator = this.paginator;

      // **Calculate and update the total percentage**
      this.getTotalPercentage();
      this.loadingService.setLoading(false);
    });
  }




  clearAll() {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate1 = fy.startDate;
    this.endDate1 = fy.endDate;
    this.TSumDays ='';
    this.efficiencyReports = [];
    this.dataSource = new MatTableDataSource(this.efficiencyReports);
    this.dataSource.paginator = this.paginator;
    this.selectedCentreCode = []
    this.selectedCentre = [];
  }

  protected readonly Math = Math;

  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.dataSource.filter = filterValue.trim().toLowerCase();
  // }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase().trim();

    if (!filterValue) {
      // Reset to full data
      this.filteredEfficiencyReports = [...this.efficiencyReports]; // keep original full data
    } else {
      this.filteredEfficiencyReports = this.efficiencyReports.filter(element => {
        const combinedStr = (
          this.getCentreNameByCode(element.centreCode) +
          element.available +
          element.occupied +
          element.totalOccupancy +
          ((element.occupied / element.totalOccupancy) * 100).toFixed(2)
        ).toLowerCase();

        return combinedStr.includes(filterValue);
      });
    }

    // Push filtered data into the table
    this.dataSource.data = this.filteredEfficiencyReports;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportexcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(document.getElementById('EfficiencyReportsTable'));
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Efficiency-Report.xlsx');
  }

  getFooterColumns(): string[] {
    return ['Sr', 'centreName', 'totalUnit','noOfDays','totalOccupancy', 'occupied', 'available', 'percentage'];
  }

  getTotal(field: keyof EfficiencyReports): number {
    return this.efficiencyReports.reduce((sum, item) => sum + (item[field] || 0), 0);
  }

  getTotalPercentage(): number {
    const totalOccupied = this.getTotal('occupied');
    const totalOccupancy = this.getTotal('totalOccupancy');
    return totalOccupancy > 0 ? (totalOccupied / totalOccupancy) * 100 : 0;
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
